<template>
  <div class="connection-container">
    <h2 class="title title--main">My Connection Requests</h2>
    <div class="message-container" v-if="!hasMyRequests">
      <p class="message">Find a partner school to collaborate with by creating a new connection request.</p>
      <b-button :disabled="false"
                @click="newRequest"
                class="new-request-button"
                btn-text="Go!"/>
    </div>
    <div class="card-connection-wrapper">
      <div class="card" v-for="request in myRequestList" :key="request.id">
        <h2 class="title title--card">{{request.classroomName}}</h2>
        <div class="card-connection-body">
          <div class="info-section">
            <p class="subtitle subtitle--description">
              Course: <span>{{truncateString(request.courseName, 25)}}</span> 
            </p>
            <p class="subtitle subtitle--description">
              Created: <span>{{formattedDate(request.create)}}</span> 
            </p>
            <p class="subtitle subtitle--description">
              Expires: <span>{{formattedDate(request.expire)}}</span> 
            </p>
            <p class="subtitle subtitle--description">
              Views: <span>{{request.views}}</span> 
            </p>
          </div>
          <div class="button-container">
            <b-button :disabled="false"
                    @click="editRequest(request)"
                    btn-text="Edit"/>
          </div>
        </div>
      </div>
    </div>
    <b-button :disabled="false"
              @click="newRequest"
              class="button-new-request"
              v-if="hasMyRequests"
              btn-text="New Request"/>
    <new-connection-request-popup :request-detail="requestSelected" ref="newRequest" @save-request="getRequestList()"/>
    <b-overlay no-wrap :show="loading"/>
  </div>
</template>

<script>
import {Button} from "@/core/components/Button"
import NewConnectionRequestPopup from './NewConnectionRequestPopup'
import {LibrarianService} from '@/core/Services'
import moment from 'moment'

export default {
  name: "MyConnectionRequests",
  components: {
    'b-button': Button,
    NewConnectionRequestPopup
  },
  mounted() {
    this.getRequestList()
  },
  data() {
    return {
      loading: false,
      myRequestList: [],
      requestSelected: {}
    }
  },
  computed: {
    hasMyRequests() {
      this.$emit('on-change-my-request', !!this.myRequestList.length)
      return !!this.myRequestList.length
    }
  },
  methods: {
    getRequestList() {
      this.loading = true
      LibrarianService.getMyRequests().then((res) => {
        if (res.success) {
          this.myRequestList = res.data.map((request) => ({
            id: request.id,
            name: request.name,
            requestText: request.text_request,
            expire: request.expire_at,
            studentAges: request.age_range_id,
            topics: request.librarian_topics_id,
            views: request.views_number,
            classroomName: request.classroom_name,
            create: request.created_at,
            courseName: request.course?.name ?? ''
          }))
        } else {
          const errorMessage = res.message ? res.message : 'Error saving the request.'
          this.$bvModal.msgBoxOk(`${errorMessage} Please try again.`, {
            size: 'sm',
            dialogClass: 'modal-message-box',
            centered: true
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    editRequest(request) {
      this.requestSelected = request
      this.$nextTick(() => this.$refs.newRequest.open())
    },
    newRequest() {
      this.requestSelected = {}
      this.$nextTick(() => this.$refs.newRequest.open())
    },
    truncateString(str, num = 10) {
      return str.length > num ? str.slice(0, num) + "..." : str
    },
    formattedDate(date) {
      return date ? moment(date).format('DD MMM YYYY') : date
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "~@/core/styles/variables.styl"

.connection-container
  font font-opensans-regular
  font-size 20px
  margin-bottom 30px !important
  border 2px solid color-4
  border-radius 15px
  height 100%
  padding 10px
  padding-top 100px
  width 100%
  position relative

  .title
    font font-opensans-bold
    font-size 22px
  
  .title--card
    color color-55

  .subtitle
    font font-opensans-semibold
    margin 0

  .message-container
    text-align center
    position absolute
    top 20%
    left 0
    @media(max-width 1000px)
      position static
      transform none
    @media(max-width 600px)
      position static
      transform none

    .message
      font font-opensans-semibold
      color color-55
      font-size 20px
      margin 0
      padding 10px

    .new-request-button
      margin auto
      text-transform capitalize
      margin-top 8px

  .card-connection-wrapper
    max-height 680px
    overflow-y auto
    height 680px
    @media(max-width 1000px)
      height auto

  .card
    width 98%
    margin 0 auto
    border 2px solid color-4
    border-radius 15px
    padding 15px
    margin-bottom 10px
    background color-57

    .subtitle--description
      font font-opensans-bold
      max-height 70px

      span
        font font-opensans-semibold

    @media(max-width 600px)
      .title--card, .subtitle--expire
        font-size 15px

      .subtitle--description
        font-size 12px
        font font-opensans-bold

    .card-connection-body
      display flex
      justify-content space-between
      @media(max-width 600px)
        flex-direction column

      .button-container
        display flex
        align-items center
        @media(max-width 600px)
          margin-top 10px

  .button-new-request
    margin 0 auto
    position relative
    top 20px
</style>
